import { render, staticRenderFns } from "./MidiaHorizontalTextView.vue?vue&type=template&id=5217b9d4&scoped=true"
import script from "./MidiaHorizontalTextView.vue?vue&type=script&lang=js"
export * from "./MidiaHorizontalTextView.vue?vue&type=script&lang=js"
import style0 from "./MidiaHorizontalTextView.vue?vue&type=style&index=0&id=5217b9d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5217b9d4",
  null
  
)

export default component.exports